// Stripe.js loads on demand. The default "@stripe/stripe-js" entry injects
// the script as an import side effect, and billing components ride in the
// application pack, so every page (job search included) fetched Stripe.js and
// reported "Failed to load Stripe.js" whenever an ad blocker or the network
// stopped it (Sentry DIRECTDENTAL-1ZV). The "/pure" entry waits until
// loadStripe is called.
import { loadStripe } from "@stripe/stripe-js/pure"
import type { Stripe } from "@stripe/stripe-js"

// Note: Stripe key should be passed as prop or retrieved from global config
const STRIPE_KEY = 'pk_test_placeholder'

let stripePromise: Promise<Stripe | null> | null = null

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    // One promise for the page: <Elements> must keep the same stripe prop
    // across renders.
    stripePromise = loadStripe(STRIPE_KEY)
  }
  return stripePromise
}
